import React, { FC } from 'react';
import { DataSubjectDto } from '@atlas-frontend/sdk';
import {
  SectionBreadcrumbs,
  SectionBreadcrumbsProps,
} from '../../common/SectionBreadcrumbs';
import { DATA_SUBJECT_ROUTES } from './DataSubjects';

export interface DataSubjectBreadcrumbsData {
  dataSubject?: DataSubjectDto;
}

export type DataSubjectBreadcrumbsProps = Omit<
  SectionBreadcrumbsProps<DataSubjectBreadcrumbsData>,
  'routes'
>;

export const DataSubjectBreadcrumbs: FC<DataSubjectBreadcrumbsProps> = (
  props
) => <SectionBreadcrumbs {...props} routes={DATA_SUBJECT_ROUTES} />;
